import { PersonalizationTagEnum } from '@Discover/Targeting/enums/personalization-tag.enum';
import { DropdownOptionModel } from '../../../Common/Forms/models/dropdown-option.model';

export const mailMergeTagOptions: DropdownOptionModel[] = [
    // NEP-18499 new DropdownOptionModel('Name', '[%NAME%]'),
    new DropdownOptionModel(`Discover.personalizationTag.${PersonalizationTagEnum.PREFIX}`, '[%PREFIX%]'),
    new DropdownOptionModel(`Discover.personalizationTag.${PersonalizationTagEnum.FNAME}`, '[%FNAME%]'),
    new DropdownOptionModel(`Discover.personalizationTag.${PersonalizationTagEnum.LNAME}`, '[%LNAME%]'),
    new DropdownOptionModel(`Discover.personalizationTag.${PersonalizationTagEnum.OUTLET_NAME}`, '[%OUTLET_NAME%]'),
    // TODO NEP-7815 new DropdownOptionModel('[%CITY%]', '[%CITY%]'),
    new DropdownOptionModel(`Discover.personalizationTag.${PersonalizationTagEnum.X_HANDLE}`, '[%X_HANDLE%]'),
    new DropdownOptionModel(`Discover.personalizationTag.${PersonalizationTagEnum.INTRO}`, '[%INTRO%]'),
    new DropdownOptionModel(`Discover.personalizationTag.${PersonalizationTagEnum.OUTRO}`, '[%OUTRO%]')
];
